module.exports = __webpack_public_path__ + "img/login03b.1107e3ca.png";